import { Routes } from '@angular/router'
import { RegistrationComponent } from './app/registration/registration.component';
import { LoginComponent } from './app/registration/login/login.component';
import { SignupComponent } from './app/registration/signup/signup.component';
import { UltilitiesComponent } from './app/ultilities/ultilities.component';
import { RolesGridComponent } from './app/ultilities/roles/roles-grid/roles-grid.component';
import { RolesFormComponent } from './app/ultilities/roles/roles-form/roles-form.component';
import { UserGridComponent } from './app/ultilities/user/user-grid/user-grid.component';
import { UserFormComponent } from './app/ultilities/user/user-form/user-form.component';
import { ClaimGridComponent } from './app/ultilities/claims/claim-grid/claim-grid.component';
import { ClaimFormComponent } from './app/ultilities/claims/claim-form/claim-form.component';
import { AuthGuard } from './app/auth/auth.guard';
import { ChangePasswordComponent } from './app/ultilities/change-password/change-password.component';
import { ForgotPasswordComponent } from './app/registration/forgot-password/forgot-password.component';
import { HomepageComponent } from './app/homepage/homepage.component';
import { LeadComponent } from './app/Pages/lead/lead.component';
import { LeadGridComponent } from './app/Pages/Lead/lead-grid/lead-grid.component';
import { LeadFormComponent } from './app/Pages/Lead/lead-form/lead-form.component';
import { ActivityFormComponent } from './app/Pages/activities/activity-form/activity-form.component';
import { ActivityGridComponent } from './app/Pages/activities/activity-grid/activity-grid.component';
import { ActivitiesComponent } from './app/Pages/activities/activities.component';
import { ReportsComponent } from './app/Pages/reports/reports.component';
import { ReportGridComponent } from './app/Pages/reports/report-grid/report-grid.component';
import { ReportFormComponent } from './app/Pages/reports/report-form/report-form.component';
import { SalesOrdersComponent } from './app/Pages/sales-orders/sales-orders.component';
import { SalesOrderGridComponent } from './app/Pages/sales-orders/sales-order-grid/sales-order-grid.component';
import { SalesOrderFormComponent } from './app/Pages/sales-orders/sales-order-form/sales-order-form.component';
import { AssignLeadGridComponent } from './app/Pages/lead/assign-leads/assign-lead-grid/assign-lead-grid.component';
import { CompanyProfileGridComponent } from './app/ultilities/company-profile/company-profile-grid/company-profile-grid.component';
import { CompanyProfileFormComponent } from './app/ultilities/company-profile/company-profile-form/company-profile-form.component';
import { DivisionDeptGridComponent } from './app/ultilities/division-department/division-dept-grid/division-dept-grid.component';
import { DivisionDeptFormComponent } from './app/ultilities/division-department/division-dept-form/division-dept-form.component';
import { EmpMasterGridComponent } from './app/ultilities/employee-master/emp-master-grid/emp-master-grid.component';
import { EmpMasterFormComponent } from './app/ultilities/employee-master/emp-master-form/emp-master-form.component';
import { ManageComponent } from './app/Pages/manage/manage.component';
import { VenderGridComponent } from './app/Pages/Manage/vender/vender-grid/vender-grid.component';
import { VenderFromComponent } from './app/Pages/manage/vender/vender-from/vender-from.component';
import { ProductGridComponent } from './app/Pages/Manage/products/product-grid/product-grid.component';
import { ProductFormComponent } from './app/Pages/Manage/products/product-form/product-form.component';
import { SalseQuotationGridComponent } from './app/Pages/sales-orders/sales-quotation/salse-quotation-grid/salse-quotation-grid.component';
import { SalseQuotationFormComponent } from './app/Pages/sales-orders/sales-quotation/salse-quotation-form/salse-quotation-form.component';
import { PerformaInvoiceGridComponent } from './app/Pages/sales-orders/performa-invoice/performa-invoice-grid/performa-invoice-grid.component';
import { PerformaInvoiceFormComponent } from './app/Pages/sales-orders/performa-invoice/performa-invoice-form/performa-invoice-form.component';
import { SalesDeliveryChallanGridComponent } from './app/Pages/sales-orders/sales-delivery-challan/sales-delivery-challan-grid/sales-delivery-challan-grid.component';
import { SalesDeliveryChallanFormComponent } from './app/Pages/sales-orders/sales-delivery-challan/sales-delivery-challan-form/sales-delivery-challan-form.component';
import { TaxInvoiceGridComponent } from './app/Pages/sales-orders/tax-invoice/tax-invoice-grid/tax-invoice-grid.component';
import { TaxInvoiceFormComponent } from './app/Pages/sales-orders/tax-invoice/tax-invoice-form/tax-invoice-form.component';
import { TaxInvoiceRetailGridComponent } from './app/Pages/sales-orders/tax-invoice-retail/tax-invoice-retail-grid/tax-invoice-retail-grid.component';
import { TaxInvoiceRetailFormComponent } from './app/Pages/sales-orders/tax-invoice-retail/tax-invoice-retail-form/tax-invoice-retail-form.component';
import { ReceiptConfirmationGridComponent } from './app/Pages/sales-orders/receipt-confirmation/receipt-confirmation-grid/receipt-confirmation-grid.component';
import { ReceiptConfirmationFormComponent } from './app/Pages/sales-orders/receipt-confirmation/receipt-confirmation-form/receipt-confirmation-form.component';
import { ArReceiptGridComponent } from './app/Pages/sales-orders/accounts-receivable-receipt/ar-receipt-grid/ar-receipt-grid.component';
import { ArReceiptFormComponent } from './app/Pages/sales-orders/accounts-receivable-receipt/ar-receipt-form/ar-receipt-form.component';
import { PurchaseComponent } from './app/Pages/purchase/purchase.component';
import { PurchaseQuotationGridComponent } from './app/Pages/purchase/purchase-quotation/purchase-quotation-grid/purchase-quotation-grid.component';
import { PurchaseQuotationFormComponent } from './app/Pages/purchase/purchase-quotation/purchase-quotation-form/purchase-quotation-form.component';
import { QuotationComparisonGridComponent } from './app/Pages/purchase/quotation-comparison/quotation-comparison-grid/quotation-comparison-grid.component';
import { QuotationComparisonFormComponent } from './app/Pages/purchase/quotation-comparison/quotation-comparison-form/quotation-comparison-form.component';
import { QuotationApprovalGridComponent } from './app/Pages/purchase/quotation-approval/quotation-approval-grid/quotation-approval-grid.component';
import { QuotationApprovalFormComponent } from './app/Pages/purchase/quotation-approval/quotation-approval-form/quotation-approval-form.component';
import { PurchaseOrderGridComponent } from './app/Pages/purchase/purchase-order/purchase-order-grid/purchase-order-grid.component';
import { PurchaseOrderFormComponent } from './app/Pages/purchase/purchase-order/purchase-order-form/purchase-order-form.component';
import { QdChallanGridComponent } from './app/Pages/purchase/quotation-delivery-challan/qd-challan-grid/qd-challan-grid.component';
import { QdChallanFormComponent } from './app/Pages/purchase/quotation-delivery-challan/qd-challan-form/qd-challan-form.component';
import { MrNoteGridComponent } from './app/Pages/purchase/material-receipt-note/mr-note-grid/mr-note-grid.component';
import { MrNoteFormComponent } from './app/Pages/purchase/material-receipt-note/mr-note-form/mr-note-form.component';
import { MrnApprovalGridComponent } from './app/Pages/purchase/mrn-approval/mrn-approval-grid/mrn-approval-grid.component';
import { MrnApprovalFormComponent } from './app/Pages/purchase/mrn-approval/mrn-approval-form/mrn-approval-form.component';
import { ArPaymentGridComponent } from './app/Pages/purchase/account-receivable-payment/ar-payment-grid/ar-payment-grid.component';
import { ArPaymentFormComponent } from './app/Pages/purchase/account-receivable-payment/ar-payment-form/ar-payment-form.component';
import { PaymentApprovalGridComponent } from './app/Pages/purchase/payment-approval/payment-approval-grid/payment-approval-grid.component';
import { PaymentApprovalFormComponent } from './app/Pages/purchase/payment-approval/payment-approval-form/payment-approval-form.component';
import { ProductViewComponent } from './app/pages/manage/products/product-view/product-view.component';
import { ProfileComponent } from './app/Pages/user/profile/profile.component';
import { FeedbackComponent } from './app/Pages/User/feedback/feedback.component';
import { ArReceiptViewComponent } from './app/Pages/sales-orders/accounts-receivable-receipt/ar-receipt-view/ar-receipt-view.component';
import { DesignationComponent } from './app/Pages/manage/designation/designation.component';
import { DesignationGridComponent } from './app/Pages/manage/designation/designation-grid/designation-grid.component';
import { DesignationFormComponent } from './app/Pages/manage/designation/designation-form/designation-form.component';
import { QualificationComponent } from './app/Pages/manage/qualification/qualification.component';
import { QualificationgridComponent } from './app/Pages/manage/qualification/qualificationgrid/qualificationgrid.component';
import { QualificationformComponent } from './app/Pages/manage/qualification/qualificationform/qualificationform.component';
import { SpecilizationComponent } from './app/Pages/manage/specilization/specilization.component';
import { SpecilizationgridComponent } from './app/Pages/manage/specilization/specilizationgrid/specilizationgrid.component';
import { SpecilizationformComponent } from './app/Pages/manage/specilization/specilizationform/specilizationform.component';
import { DisciplineComponent } from './app/Pages/manage/discipline/discipline.component';
import { DisciplinegridComponent } from './app/Pages/manage/discipline/disciplinegrid/disciplinegrid.component';
import { DisciplineformComponent } from './app/Pages/manage/discipline/disciplineform/disciplineform.component';
import { HospitalComponent } from './app/Pages/manage/hospital/hospital.component';
import { HospitalgridComponent } from './app/Pages/manage/hospital/hospitalgrid/hospitalgrid.component';
import { HospitalformComponent } from './app/Pages/manage/hospital/hospitalform/hospitalform.component';
import { DistrictComponent } from './app/Pages/manage/district/district.component';
import { DistrictgridComponent } from './app/Pages/manage/district/districtgrid/districtgrid.component';
import { DistrictformComponent } from './app/Pages/manage/district/districtform/districtform.component';
import { StateComponent } from './app/Pages/manage/state/state.component';
import { StategridComponent } from './app/Pages/manage/state/stategrid/stategrid.component';
import { StateformComponent } from './app/Pages/manage/state/stateform/stateform.component';
import { NetworkComponent } from './app/Pages/manage/network/network.component';
import { NetworkgridComponent } from './app/Pages/manage/network/networkgrid/networkgrid.component';
import { NetworkformComponent } from './app/Pages/manage/network/networkform/networkform.component';
import { VendorformComponent } from './app/Pages/manage/vendor/vendorform/vendorform.component';
import { VendorgridComponent } from './app/Pages/manage/vendor/vendorgrid/vendorgrid.component';
import { VendorComponent } from './app/Pages/manage/vendor/vendor.component';
import { TasksComponent } from './app/Pages/tasks/tasks.component';
import { ExistingpatientComponent } from './app/Pages/tasks/existingpatient/existingpatient.component';
import { ExistingpatientformComponent } from './app/Pages/tasks/existingpatient/existingpatientform/existingpatientform.component';
import { ExistingpatientgridComponent } from './app/Pages/tasks/existingpatient/existingpatientgrid/existingpatientgrid.component';
import { NewpatientComponent } from './app/Pages/tasks/newpatient/newpatient.component';
import { NewpatientformComponent } from './app/Pages/tasks/newpatient/newpatientform/newpatientform.component';
import { NewpatientgridComponent } from './app/Pages/tasks/newpatient/newpatientgrid/newpatientgrid.component';
import { PatientstatusComponent } from './app/Pages/tasks/patientstatus/patientstatus.component';
import { PatientstatusformComponent } from './app/Pages/tasks/patientstatus/patientstatusform/patientstatusform.component';
import { PatientstatusgridComponent } from './app/Pages/tasks/patientstatus/patientstatusgrid/patientstatusgrid.component';
import { DoctorComponent } from './app/Pages/manage/doctor/doctor.component';
import { DoctorgridComponent } from './app/Pages/manage/doctor/doctorgrid/doctorgrid.component';
import { DoctorformComponent } from './app/Pages/manage/doctor/doctorform/doctorform.component';
import { AssistantComponent } from './app/Pages/manage/assistant/assistant.component';
import { AssistantgridComponent } from './app/Pages/manage/assistant/assistantgrid/assistantgrid.component';
import { AssistantformComponent } from './app/Pages/manage/assistant/assistantform/assistantform.component';
import { VlegridComponent } from './app/Pages/manage/vle/vlegrid/vlegrid.component';
import { VleComponent } from './app/Pages/manage/vle/vle.component';
import { VleformComponent } from './app/Pages/manage/vle/vleform/vleform.component';
// import { NavigationComponent } from './app/home/navigation/navigation.component';
// import { ServiceComponent } from './app/home/service/service.component';
import { HomeComponent } from './app/home/home.component';
import { ConsultancyComponent } from './app/Pages/tasks/consultancy/consultancy.component';
import { ConsultancygridComponent } from './app/Pages/tasks/consultancy/consultancygrid/consultancygrid.component';
import { ConsultancyformComponent } from './app/Pages/tasks/consultancy/consultancyform/consultancyform.component';
import { DoctorSignUpComponent } from './app/registration/doctor-sign-up/doctor-sign-up.component';
import { PharmasistSignUpComponent } from './app/registration/pharmasist-sign-up/pharmasist-sign-up.component';
import { PatientSignUpComponent } from './app/registration/patient-sign-up/patient-sign-up.component';
import { PatientLoginComponent } from './app/registration/patient-login/patient-login.component';
import { PharmacyLoginComponent } from './app/registration/pharmacy-login/pharmacy-login.component';
import { DiagnosticLoginComponent } from './app/registration/diagnostic-login/diagnostic-login.component';
import { DoctorLoginComponent } from './app/registration/doctor-login/doctor-login.component';
import { DiagnosticSignupComponent } from './app/registration/diagnostic-login/diagnostic-signup/diagnostic-signup.component';
import { PatientProfileComponent } from './app/registration/patient-profile/patient-profile.component';
import { PatientViewGridComponent } from './app/Pages/tasks/patientprofile-view/patient-view-grid/patient-view-grid.component';
import { PatientprofileViewComponent } from './app/Pages/tasks/patientprofile-view/patientprofile-view.component';
import { PatientViewFormComponent } from './app/Pages/tasks/patientprofile-view/patient-view-form/patient-view-form.component';
import { BookAppointmentComponent } from './app/Pages/tasks/book-appointment/book-appointment.component';
import { BookAppointmentGridComponent } from './app/Pages/tasks/book-appointment/book-appointment-grid/book-appointment-grid.component';
import { BookAppointmentFormComponent } from './app/Pages/tasks/book-appointment/book-appointment-form/book-appointment-form.component';
import { PharmacyComponent } from './app/Pages/tasks/pharmacy/pharmacy.component';
import { PharmacyGridComponent } from './app/Pages/tasks/pharmacy/pharmacy-grid/pharmacy-grid.component';
import { DiagnosticTestComponent } from './app/Pages/tasks/diagnostic-test/diagnostic-test.component';
import { DiagnosticTestGridComponent } from './app/Pages/tasks/diagnostic-test/diagnostic-test-grid/diagnostic-test-grid.component';
// import { FaqComponent } from './app/home/faq/faq.component';
// import { GalleryComponent } from './app/home/gallery/gallery.component';
import { AboutComponent } from './app/home/about/about.component';
import { SupportComponent } from './app/home/support/support.component';
import { Doctor1Component } from './app/home/doctor1/doctor1.component';
import { HospitalclinicComponent } from './app/home/hospitalclinic/hospitalclinic.component';
import { QuicklinkComponent } from './app/home/quicklinks/quicklinks.component';
import { NavigationComponent } from './app/home/navigation/navigation.component';
import { ServiceComponent } from './app/home/service/service.component';
import { FaqComponent } from './app/home/faq/faq.component';
import { GalleryComponent } from './app/home/gallery/gallery.component';
import { MyConsulationRequestComponent } from './app/Pages/tasks/MyConsulationRequest/MyConsulationRequest.component';
import { MyConsulationRequestGridComponent } from './app/Pages/tasks/MyConsulationRequest/MyConsulationRequest-grid/MyConsulationRequestgrid.component';
import { MyConsulationRequestFormComponent } from './app/Pages/tasks/MyConsulationRequest/MyConsulationRequest-form/MyConsulationRequest-form.component';
import { ContactUsComponent } from './app/home/ContactUs/ContactUs.component';
import { CareerComponent } from './app/home/career/career.component';
// import { VleformComponent } from './Pages/manage/vle/vleform/vleform.component';
// import { VlegridComponent } from './Pages/manage/vle/vlegrid/vlegrid.component';
// import { VleComponent } from './Pages/manage/vle/vle.component';

export const appRoutes: Routes = [
    {
        path: 'home', component: HomepageComponent, canActivate: [AuthGuard],
        children: [
            {
                path: 'password', component: UltilitiesComponent,
                children: [{ path: '', component: ChangePasswordComponent }]
            },
            {
                path: 'password/:userId', component: UltilitiesComponent,
                children: [{ path: '', component: ChangePasswordComponent }]
            },
            {
                path: 'rolesgrid', component: UltilitiesComponent,
                children: [{ path: '', component: RolesGridComponent },
                { path: 'rolesform', component: RolesFormComponent },
                { path: 'rolesform/:roleId/:mode', component: RolesFormComponent }
                ]
            },
            {
                path: 'user', component: UltilitiesComponent,
                children: [{ path: '', component: UserGridComponent },
                { path: 'userform', component: UserFormComponent },
                { path: 'userform/:Id/:mode', component: UserFormComponent }
                ]
            },
           
            {
                path: 'claims', component: UltilitiesComponent,
                children: [{ path: '', component: ClaimGridComponent },
                { path: 'claimform/:roleId/:roleName', component: ClaimFormComponent }
                ]
            },
            {
                path: 'company-profile', component: UltilitiesComponent,
                children: [
                    { path: '', component: CompanyProfileGridComponent },
                    { path: 'company-profile-form', component: CompanyProfileFormComponent }
                ]
            },
            {
                path: 'division-department', component: UltilitiesComponent,
                children: [
                    { path: '', component: DivisionDeptGridComponent },
                    { path: 'division-department-form', component: DivisionDeptFormComponent },

                ]
            },
            {
                path: 'employee-master', component: UltilitiesComponent,
                children: [
                    { path: '', component: EmpMasterGridComponent },
                    { path: 'employee-master-form', component: EmpMasterFormComponent },
                    { path: 'employee-master-form/:emp_code/:mode', component: EmpMasterFormComponent }
                ]
            },

            //Routing - Start   
            // User
            { path: 'profile', component: ProfileComponent },
            { path: 'feedback', component: FeedbackComponent },
            //Manage
            {
                path: 'manage', component: ManageComponent,
                children: [
                    { path: '', component: VenderGridComponent },
                    { path: 'vendor-form', component: VenderFromComponent }
                ]
            },
            {
                path: 'designation', component: DesignationComponent,
                children: [
                    { path: '', component: DesignationGridComponent },
                    { path: 'designation-form', component: DesignationFormComponent },
                    { path: 'designation-form/:DE_Id/:mode', component: DesignationFormComponent }
                ]
            },
            {
                path: 'qualification', component: QualificationComponent,
                children: [
                    {
                        path: '', component: QualificationgridComponent
                    },
                    {
                        path: 'qualification-form', component: QualificationformComponent
                    },
                    {
                        path: 'qualification-form/:QU_Id/:mode', component: QualificationformComponent
                    }
                ]
            },
            {
                path: 'specilization', component: SpecilizationComponent,
                children: [
                    {
                        path: '', component: SpecilizationgridComponent
                    },
                    {
                        path: 'specilization-form', component: SpecilizationformComponent
                    }
                    ,
                    {
                        path: 'specilization-form/:SP_Id/:mode', component: SpecilizationformComponent
                    }

                ]
            },
            {
                path: 'discipline', component: DisciplineComponent,
                children: [
                    {
                        path: '', component: DisciplinegridComponent
                    },
                    {
                        path: 'discipline-form', component: DisciplineformComponent
                    },
                    {
                        path: 'discipline-form/:CD_Id/:mode', component: DisciplineformComponent
                    }
                ]
            },
            {
                path: 'hospital', component: HospitalComponent,
                children: [
                    {
                        path: '', component: HospitalgridComponent
                    },
                    {
                        path: 'hospital-form', component: HospitalformComponent
                    },
                    {
                        path: 'hospital-form/:HO_Id/:mode', component: HospitalformComponent
                    }
                ]
            },
            {
                path: 'district', component: DistrictComponent,
                children: [
                    {
                        path: '', component: DistrictgridComponent
                    },
                    {
                        path: 'district-form', component: DistrictformComponent
                    },
                    {
                        path: 'district-form/:DI_Id/:mode', component: DistrictformComponent
                    }
                ]
            },
            {
                path: 'state', component: StateComponent,
                children: [
                    {
                        path: '', component: StategridComponent
                    },
                    {
                        path: 'state-form', component: StateformComponent
                    },
                    {
                        path:'state-form/:ST_Id/:mode',component: StateformComponent
                    }
                ]
            },
            {
                path: 'network', component: NetworkComponent,
                children: [
                    {
                        path: '', component: NetworkgridComponent
                    },
                    {
                        path: 'network-form', component: NetworkformComponent
                    },
                    {
                        path: 'network-form/:NE_Id/:mode', component: NetworkformComponent
                    }
                ]
            },
            {
                path: 'vendor', component: VendorComponent,
                children: [
                    {
                        path: '', component: VendorgridComponent
                    },
                    {
                        path: 'vendor-form', component: VendorformComponent
                    },
                    {
                        path:'vendor-form/:VE_Id/:mode',component: VendorformComponent
                    }
                ]
            },
            {
            path:'VLE', component: VleComponent,
                children:[
                    {
                        path:'', component: VlegridComponent
                    },
                    {
                        path:'vle-form',component: VleformComponent
                    },
                    {
                        path:'vle-form/:VL_Id/:mode',component: VleformComponent
                    }
                ]
            },
            {
                path: 'assistant', component: AssistantComponent,
                children: [
                    {
                        path: '', component: AssistantgridComponent
                    },
                    {
                        path: 'assistant-form', component: AssistantformComponent
                    },
                    {
                        path:'assistant-form/:AS_Id/:mode', component: AssistantformComponent
                    }
                ]
            },
            {
                path: 'doctor', component: DoctorComponent,
                children: [
                    {
                        path: '', component: DoctorgridComponent
                    },
                    {
                        path: 'doctor-form', component: DoctorformComponent
                    },
                    { path: 'doctor-form/:DO_Id/:mode', component: DoctorformComponent },

                ]
            },
            // {
            //     path: 'products', component: ManageComponent,
            //     children: [
            //         { path: '', component: ProductGridComponent },
            //         { path: 'product-form', component: ProductFormComponent },
            //         { path: 'product-view', component: ProductViewComponent }
            //     ]
            // },
            {
                path: 'existingpatient', component: ExistingpatientComponent,
                children: [
                    {
                        path: '', component: ExistingpatientgridComponent
                    },
                    {
                        path: 'existingpatient-form', component: ExistingpatientformComponent
                    }
                ]

                
            },

            // {
            //     path: 'PatientView', component: PatientViewGridComponent,
            //     children: [
            //         {
            //             path: '', component: PatientViewGridComponent
            //         },
            //         {
            //             path: 'PatientView-form', component: PatientViewFormComponent
            //         }
            //     ]

                
            // },
            {
                path:'myconsultation', component: MyConsulationRequestComponent,
                children:[
                    {
                        path:'', component: MyConsulationRequestGridComponent
                    },
                    {
                        path:'myconsultation-form', component:  MyConsulationRequestFormComponent,

                    }
                   
                ]
            },

            {
                path:'PatientView', component: PatientprofileViewComponent,
                children:[
                    {
                        path:'', component: PatientViewGridComponent
                    },
                    {
                        path:'PatientView-form', component: PatientViewFormComponent
                    },
                    {
                        path:'PatientView-form/:PR_Id', component: PatientViewFormComponent
                    }
                ]
            },
            
            {
                path: 'newpatient', component: NewpatientComponent,
                children: [
                    {
                        path: '', component: NewpatientgridComponent
                    },
                    {
                        path: 'newpatient-form', component: NewpatientformComponent
                    },
                    {
                        path: 'newpatient-form/:PR_Id/:mode', component: NewpatientformComponent
                    }
                ]
            },
            {
                path: 'patientstatus', component: PatientstatusComponent,
                children: [
                    {
                        path: '', component: PatientstatusformComponent
                    },
                    {
                        path: 'patientstatus-form', component: PatientstatusgridComponent
                    }
                ]
            },
            {
                path:'consultancy', component: ConsultancyComponent,
                children:[
                    {
                        path:'', component: ConsultancygridComponent
                    },
                    {
                        path:'consultancy-form', component: ConsultancyformComponent
                    },
                    {
                        path:'consultancy-form/:PR_Id', component: ConsultancyformComponent
                    }
                ]
            },
            {
                path:'bookappointment', component: BookAppointmentComponent,
                children:[
                    {
                        path:'', component: BookAppointmentGridComponent
                    },
                    {
                        path:'bookappointment-form', component: BookAppointmentFormComponent
                    },
                    // {
                    //     path:'consultancy-form/:PR_Id', component: ConsultancyformComponent
                    // }
                ]
            },

            {
                path:'PharmacyRequest', component: PharmacyComponent,
                children:[
                    {
                        path:'', component: PharmacyGridComponent
                    },
                  
                    
                ]
            },

             {
                path:'DiagnosticTest', component: DiagnosticTestComponent,
                children:[
                    {
                        path:'', component: DiagnosticTestGridComponent
                    },
                  
                    
                ]
            },



        ],

    },
    {
        path:'homepages', component: HomeComponent,
        children:[
           {
               path:'index', component: NavigationComponent
           },
           {
               path:'service', component: ServiceComponent
           },
           {
            path:'faq', component: FaqComponent
           },
           {
            path:'gallery', component: GalleryComponent
           },
           {
            path:'about', component: AboutComponent
           },
           {
            path:'support', component: SupportComponent
           },
           {
            path:'doctor', component: Doctor1Component
           },
           {
            path:'hospital', component: HospitalclinicComponent
           },
           {
            path:'quicklink', component: QuicklinkComponent
           },
           {
            path:'contactus', component: ContactUsComponent
           },
           {
            path:'career', component: CareerComponent
           },
        ]
    },
 

    {
        path: 'login', component: RegistrationComponent,
        children: [{ path: '', component: LoginComponent }]
    },
     {
        path: 'doctor-login', component: RegistrationComponent,
        children: [{ path: '', component: DoctorLoginComponent }]
    },
      {
        path: 'Diagnostic-login', component: RegistrationComponent,
        children: [{ path: '', component: DiagnosticLoginComponent }]
    },

    {
        path: 'Diagnostic-signin', component: RegistrationComponent,
        children: [{ path: '', component: DiagnosticSignupComponent }]
    },
     {
        path: 'Pharmacy-login', component: RegistrationComponent,
        children: [{ path: '', component: PharmacyLoginComponent }]
    },
    {
        path: 'Patient-login', component: RegistrationComponent,
        children: [{ path: '', component: PatientLoginComponent }]
    },
 {
        path: 'Patientsignup', component: RegistrationComponent,
        children: [{ path: '', component: PatientSignUpComponent }]
    },

    {
        path: 'signup', component: RegistrationComponent,
        children: [{ path: '', component: SignupComponent }]
    },
     {
        path: 'doctorsignup', component: RegistrationComponent,
        children: [{ path: '', component: DoctorSignUpComponent }]
    },
      {
        path: 'Pharmacysignup', component: RegistrationComponent,
        children: [{ path: '', component: PharmasistSignUpComponent }]
    },

    {
        path: 'Pharmacysignup', component: RegistrationComponent,
        children: [{ path: '', component: PharmasistSignUpComponent }]
    },
    {
        path: 'PatientProfile', component: RegistrationComponent,
        children: [{ path: '', component: PatientProfileComponent }]
    },
    {
        path: 'networkhosp', component: RegistrationComponent,
        children: [{ path: '', component: EmpMasterFormComponent }]
    },
    {
        path: 'specialityhosp', component: RegistrationComponent,
        children: [{ path: '', component: EmpMasterGridComponent }]
    },

  

    {
        path: 'forgot-password', component: RegistrationComponent,
        children: [{ path: '', component: ForgotPasswordComponent }]
    },
    // { path: '', redirectTo: '/login', pathMatch: 'full' },
    { path: '', redirectTo: '/homepages/index', pathMatch: 'full' },

];


// WEBPACK FOOTER //
// ./src/route.ts